import React, { useState, useEffect } from 'react';
import './Header/Css/sideBar.css';
import PermissionServices from '../services/PermissionServices';

const menuItems = [
  { name: 'Dashboard', key: 'dashboard' },
  { name: 'Booking', key: 'booking' },
  { name: 'User Manager', key: 'user-manager' },
  { name: 'Investor Management', key: 'investor-management' },
  { name: 'Notification', key: 'notification-list' },
  { name: 'Cottage List', key: 'cottage-list' },
  { name: 'Category', key: 'category-list' },
  { name: 'App Baner', key: 'app-banner-list' },
  { name: 'Coupon Code Manager', key: 'coupon-code' },
  { name: 'Inventory List', key: 'inventory-list' },
  { name: 'Manage Review', key: 'manage-review' },
  { name: 'Pages', key: 'pages' },
  { name: 'Help Center', key: 'help' },

];

const roles = ['User', 'Investor', 'Helper'];

function UserPermission({ admin, closeModal }) {
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await PermissionServices.getPermission();
        const data = response.data;
        const formattedPermissions = data.reduce((acc, item) => {
          acc[item.menuItem] = item.roles;
          return acc;
        }, {});
        setPermissions(formattedPermissions);
      } catch (error) {
        console.error('Error loading permissions:', error);
        setError('Error loading permissions. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  const handleCheckboxChange = (menuItem, role) => {
    setPermissions(prevPermissions => ({
      ...prevPermissions,
      [menuItem]: {
        ...prevPermissions[menuItem],
        [role]: !prevPermissions[menuItem]?.[role]
      }
    }));
  };

  const handleSavePermissions = async () => {
    const formattedPermissions = Object.entries(permissions).map(([menuItem, roles]) => ({
      menuItem,
      roles
    }));

    try {
      await PermissionServices.savePermission({ permissions: formattedPermissions });
      alert('Permissions saved successfully');
      closeModal();
      // console.log('Permissions saved successfully');
    } catch (error) {
      console.error('Error saving permissions:', error);
      setError('Error saving permissions. Please try again.');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Permission</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <div className="user-permission-container">
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p>{error}</p>
                    ) : (
                      <>
                        <div style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
                          <table className="user-permission-table">
                            <thead>
                              <tr>
                                <th>Menu Item</th>
                                {roles.map(role => (
                                  <th key={role}>{role}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {menuItems.map(menuItem => (
                                <tr key={menuItem.key}>
                                  <td>{menuItem.name}</td>
                                  {roles.map(role => (
                                    <td key={role}>
                                      <input
                                        type="checkbox"
                                        checked={permissions[menuItem.key]?.[role] || false}
                                        onChange={() => handleCheckboxChange(menuItem.key, role)}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <button className="site-btn-green" onClick={handleSavePermissions}>Apply</button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default UserPermission;
